import parse from 'date-fns/parse'

const normalizedPastPregnancies = data => {
  return data.sort((a, b) => {
    return (
      parse(b.outcomeDate, 'yyyy-MM-dd', new Date()) -
      parse(a.outcomeDate, 'yyyy-MM-dd', new Date())
    )
  })
}

const setObstetricData = (state, obstetricData) => {
  const orderedObstreticData = {
    ...obstetricData,
    pastPregnancies: normalizedPastPregnancies(obstetricData.pastPregnancies)
  }

  Object.assign(state, { obstetricData: orderedObstreticData })
}

const clearState = state => {
  state.obstetricData = undefined
}

export default {
  setObstetricData,
  clearState
}
